export const PACIFICA = 'PACIFICA';
export const BLANCA = 'BLANCA';
export const FRAGRANCE_FREE = 'frag_free';
export const FREE = 'Fragrance-Free';
